export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获得配置
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/get_config

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "account": "159***510",
	        "lottery_time": 0,
	        "had_lottery_time": 0,
	        "signCount": 0,
	        "today_signed": 0,
	        "is_old_account": 0,
	        "session_id": "cnO1G2DsMQfQBc2ZA33r9inajpTqH1PYh8L6hsPV",
	        "request_id": "152cf818c1b9220869a5edb7e84e8f392bf06a5e"
	    }
	 }
		*/
  service.getConfig = function() {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/get_config', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "account": "脱敏账号",
            "add_up_prize": "累计档位已解锁奖励id列表",
            "follow_status": "是否已完成关注任务（1-是，0-否）",
            "had_lottery_time": "已抽奖次数",
            "is_old_account": "是否为老玩家账号",
            "lottery_time": "可抽奖次数",
            "signCount": "每日签到总数",
            "today_like_count": "今日点赞进度（0-5）",
            "today_signed": "今天是否已签到",
            "uid": "分享标识（激活账号ID）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20006",
        "description": "账号未激活，无法进行操作"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得账号绑定手机号
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/get_phone

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "phone": "159***519",
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "60c2fb3086f7d2760c6041d8a90dcfeed70a87d4"
	    }
	 }
		*/
  service.getPhone = function() {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/get_phone', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "phone": "手机号"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得绑定手机号验证码
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/get_phone_code

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "7bdad099066ca2925a22b84aea663cd252872933"
	    }
	 }
		*/
  service.getPhoneCode = function(params) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/get_phone_code', params).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10316",
        "description": "参数缺失"
      }, {
        "code": "-10317",
        "description": "参数类型错误"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "极验验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }, {
        "code": "-10605",
        "description": "图片验证码已过期，请重新刷新"
      }, {
        "code": "-10606",
        "description": "顶象验证失败"
      }, {
        "code": "-12304",
        "description": "手机号OpenId参数缺失"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		激活账号
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/activate?id_num=121233313112123&code=736643

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "lottery_time": 50,
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "f79be5537884264faaaa32805ee6c3b914bfc0f4"
	    }
	 }
		*/
  service.activate = function(id_num, code, params = {}) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/activate', {
      id_num: id_num /*  身份证 */ ,
      code: code /*  参数说明 */,
      ...params
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "lottery_time": "赠送的抽奖次数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-10315",
        "description": "短信验证码已经被验证过，请重新获取"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20001",
        "description": "该账号未绑定手机号"
      }, {
        "code": "-20002",
        "description": "该账号未绑定身份证"
      }, {
        "code": "-20003",
        "description": "绑定身份证验证失败，身份证号不一致"
      }, {
        "code": "-20004",
        "description": "该账号已激活"
      }, {
        "code": "-20005",
        "description": "该绑定身份证或绑定手机号已激活账号"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		签到
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/sign

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "931300d348b5c9a592576a4bab83180949962729"
	    }
	 }
		*/
  service.sign = function() {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/sign', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20006",
        "description": "账号未激活，无法进行操作"
      }, {
        "code": "-20007",
        "description": "签到次数已满"
      }, {
        "code": "-20008",
        "description": "今日已签到"
      }, {
        "code": "-20024",
        "description": "抽奖次数获取已达180次上限"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		关注官方账号
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/follow?channel=1

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "lottery_time": 10,
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "931300d348b5c9a592576a4bab83180949962729"
	    }
	 }
		*/
  service.follow = function(channel) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/follow', {
      channel: channel /*  关注渠道（1-微信公众号，2-剑侠福利官，3-官方抖音） */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "lottery_time": "赠送的抽奖次数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20006",
        "description": "账号未激活，无法进行操作"
      }, {
        "code": "-20010",
        "description": "参数异常"
      }, {
        "code": "-20024",
        "description": "抽奖次数获取已达180次上限"
      }, {
        "code": "-20029",
        "description": "已完成过关注任务"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/lottery?lottery_type=10

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "current_total_count": 10,
	        "remain_time": 14,
	        "prize_data": [
	            7,
	            4,
	            1,
	            9,
	            7,
	            7,
	            6,
	            4,
	            8,
	            1
	        ],
	        "session_id": "sTkexm6N86coKhtEGHf9ABUt2yj22eQMHIX5u7bt",
	        "request_id": "0df0f04e376b8bc58a41fcdabed67d82143b7d7c"
	    }
	 }
		*/
  service.lottery = function(lottery_type) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/lottery', {
      lottery_type: lottery_type /*  抽奖类型（1-单抽，10-十连抽） */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "current_total_count": "总抽奖次数",
            "prize_data": "抽奖结果（奖品id数组）",
            "remain_time": "剩下抽奖次数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20006",
        "description": "账号未激活，无法进行操作"
      }, {
        "code": "-20009",
        "description": "缺少必要参数"
      }, {
        "code": "-20010",
        "description": "参数异常"
      }, {
        "code": "-20011",
        "description": "大侠尚无抽奖次数，可通过每日签到、好友点赞等任务获得抽奖次数。"
      }, {
        "code": "-20012",
        "description": "抽奖次数最高上限为180次哦"
      }, {
        "code": "-20023",
        "description": "大侠抽奖次数不足10次，可通过每日签到、好友点赞等任务获得抽奖次数。"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖记录
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/lottery_log?page=1&num=2

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "id": 2,
	                "type": 10,
	                "create_time": 1673228742
	            },
	            {
	                "id": 1,
	                "type": 10,
	                "create_time": 1673228715
	            }
	        ],
	        "count": 2,
	        "session_id": "sTkexm6N86coKhtEGHf9ABUt2yj22eQMHIX5u7bt",
	        "request_id": "6fee921fce386aa97bf10778ae30bf9d7cb0cfbc"
	    }
	 }
		*/
  service.lotteryLog = function(num, page) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/lottery_log', {
      num: num /*  每页数量 */ ,
      page: page /*  页数 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "count": "总记录数",
            "list": "抽奖记录列表"
          },
          "data{}.list[]": {
            "create_time": "创建时间",
            "id": "ID",
            "type": "抽奖类型：1-单抽，10-十连抽"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖详情
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/get_lottery_detail?id=1

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "prize_id": "7",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "4",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "1",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "9",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "7",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "7",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "6",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "4",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "8",
	                "create_time": 1673228715
	            },
	            {
	                "prize_id": "1",
	                "create_time": 1673228715
	            }
	        ],
	        "session_id": "aRIWCjwpQT1rfXd0TN79drJdVOtp7b2s3yNk6Hhb",
	        "request_id": "2b54b916e2157dda018b1eca71c8f512f1f3ea9f"
	    }
	 }
		*/
  service.getLotteryDetail = function(id) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/get_lottery_detail', {
      id: id /*  ID */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "list": "列表"
          },
          "data{}.list[]": {
            "create_time": "创建时间",
            "prize_id": "奖励id"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20009",
        "description": "缺少必要参数"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		奖励列表
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/prize_list

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "lottery_prize": [
	            {
	                "amount": 9,
	                "prize_id": "1"
	            },
	            {
	                "amount": 3,
	                "prize_id": "10"
	            },
	            {
	                "amount": 2,
	                "prize_id": "11"
	            },
	            {
	                "amount": 2,
	                "prize_id": "12"
	            },
	            {
	                "amount": 2,
	                "prize_id": "13"
	            },
	            {
	                "amount": 1,
	                "prize_id": "14"
	            },
	            {
	                "amount": 3,
	                "prize_id": "2"
	            },
	            {
	                "amount": 5,
	                "prize_id": "3"
	            },
	            {
	                "amount": 6,
	                "prize_id": "4"
	            },
	            {
	                "amount": 2,
	                "prize_id": "5"
	            },
	            {
	                "amount": 5,
	                "prize_id": "6"
	            },
	            {
	                "amount": 4,
	                "prize_id": "7"
	            },
	            {
	                "amount": 4,
	                "prize_id": "8"
	            },
	            {
	                "amount": 3,
	                "prize_id": "9"
	            }
	        ],
	        "add_up_prize": [
	            {
	                "prize_id": "17"
	            }
	        ],
	        "session_id": "sTkexm6N86coKhtEGHf9ABUt2yj22eQMHIX5u7bt",
	        "request_id": "484826fc562dbf07eb20a4dce44659f50f87b032"
	    }
	 }
		*/
  service.prizeList = function() {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/prize_list', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "add_up_prize": "累计奖励列表",
            "lottery_prize": "抽奖奖励列表"
          },
          "data{}.add_up_prize[]": {
            "prize_id": "奖励id"
          },
          "data{}.lottery_prize[]": {
            "amount": "奖励数量",
            "prize_id": "奖励id"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖次数获取记录
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/time_log?page=1&num=2

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "list": [
	            {
	                "type": 2,
	                "num": 5,
	                "create_time": 1673228742
	            },
	            {
	                "type": 1,
	                "num": 50,
	                "create_time": 1673228715
	            }
	        ],
	        "count": 2,
	        "session_id": "sTkexm6N86coKhtEGHf9ABUt2yj22eQMHIX5u7bt",
	        "request_id": "6fee921fce386aa97bf10778ae30bf9d7cb0cfbc"
	    }
	 }
		*/
  service.timeLog = function(num, page) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/time_log', {
      num: num /*  每页数量 */ ,
      page: page /*  页数 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "count": "总记录数",
            "list": "获取记录列表"
          },
          "data{}.list[]": {
            "create_time": "创建时间",
            "num": "获取的抽奖次数",
            "type": "来源：1-激活，2-签到，3-点赞，4-关注"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得客态页信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/get_like_info?uid=1

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "account": "159***510",
	        "is_active": 1,
	        "is_liked": 0,
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "544e39641505a1fea0afc9ab61c0c28fcd8ebe6c"
	    }
	 }
		*/
  service.getLikeInfo = function(uid) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/get_like_info', {
      uid: uid /*  分享标识（get_config返回的uid） */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "account": "被助力者脱敏账号",
            "is_active": "被助力者是否已激活（1-是，0-否）",
            "is_liked": "当前微信今日是否已点赞（1-是，0-否）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20009",
        "description": "缺少必要参数"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		点赞
		请求方法: GET, POST
		请求示例: http://<domain>/jxsj/dbkh260904/do_like?uid=1

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_liked": 1,
	        "session_id": "f9QGZuOCC13LofKXBwXd4HYxb2tib69IehTnYUnb",
	        "request_id": "544e39641505a1fea0afc9ab61c0c28fcd8ebe6c"
	    }
	 }
		*/
  service.doLike = function(uid) {
    return request.jsonp(rootAddress + '/jxsj/dbkh260904/do_like', {
      uid: uid /*  分享标识（get_config返回的uid） */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20009",
        "description": "缺少必要参数"
      }, {
        "code": "-20025",
        "description": "该好友尚未激活账号，点赞无效"
      }, {
        "code": "-20026",
        "description": "您已经为好友点赞共贺过啦~"
      }, {
        "code": "-20027",
        "description": "今日您已经点赞很多啦，明天再来试试吧~"
      }]
      		*/
      return reject(response);
    });
  };
  return service;
}
